import { render, staticRenderFns } from "./RegistrationStepFour.vue?vue&type=template&id=1ff24d63&scoped=true"
import script from "./RegistrationStepFour.vue?vue&type=script&lang=js"
export * from "./RegistrationStepFour.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepFour.vue?vue&type=style&index=0&id=1ff24d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff24d63",
  null
  
)

export default component.exports